import type { ByNameResponse } from '@partnerportal.io/apitypes';

export const NO_COMPANY_ID: string = '0';
export const NO_SUBDOMAIN: string = 'unknown';
export const NO_AUTH0_ORGANIZATION: string = 'org_unknwown';
export const NO_COMPANY_RESPONSE: ByNameResponse = { id: NO_COMPANY_ID, subdomain: NO_SUBDOMAIN, auth0OrganizationId: NO_AUTH0_ORGANIZATION } as ByNameResponse;
